import { GET_ACCOMMODATION_TYPES } from "@/actions/GET_ACCOMMODATION_TYPES.ts";
import { WarningToast } from "@/components/Notifications/WarningToast.tsx";
import { AccommodationType } from "@/helpers/types/types.ts";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export interface GetAccommodationTypesResponse {
  accommodationTypes: AccommodationType[];
}
export const useGetAccommodationTypes = () => {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery<GetAccommodationTypesResponse>(GET_ACCOMMODATION_TYPES);

  useEffect(() => {
    if (error) {
      console.error("GET_ACCOMMODATION_TYPES failed:", error.message);
      toast.custom(<WarningToast message={t("error")} />);
    }
  }, [error, t]);

  return {
    accommodationTypes: data?.accommodationTypes || [],
    getAccommodationTypesLoading: loading,
  };
};
